import React, { Fragment, Component } from 'react'
import {
  Container,
  Row, Col,
  CardBody, Card, CardTitle, CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { FileInput, generateFormData } from "../../../helpers/ui/FileInput";
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'

import CustomSelect from "../../../helpers/ui/CustomSelect"

class IndexView extends Component {

  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props)
    this.state = {
      detail: {},
      dataForm: {},
      optRedirectLink: [],
      optKeywordType: [
        {
          label: "Redirect Internal",
          value: 1
        },
        {
          label: "Redirect Eksternal",
          value: 2
        }
      ],
      optStatus: [
        {
          label: "Aktif",
          value: 1
        },
        {
          label: "Tidak Aktif",
          value: 0
        }
      ],
      selectedKeywordType: 2,
      selectedStatus: 1
    }
  }

  submitData = async () => {
    await this.updateBloc.fetchUpdate(this.state.dataForm)
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault()
    this.setState({
      dataForm: values,
      confirm: true
    })
  }

  confirmResponse = (response) => {
    let forState = {}
    switch (response) {
      case 'cancel':
        forState = {
          confirm: false
        }
        break;
      case 'confirm':
        forState = {
          loading: true,
          confirm: false
        }
        this.submitData()
        break;
      case 'success':
        forState = {
          success: false,
          redirect: true
        }
        break;
      case 'failed':
        forState = {
          failed: false
        }
        break;
      default:
    }
    this.setState(forState)
  }

  componentDidMount() {
    this.updateBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break
        default:
          break
      }
    })

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            detail: response,
            selectedKeywordType: response.nlp_keyword_type,
            selectedStatus: response.nlp_keyword_status
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    })

    this.updateBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            optRedirectLink: result.data.response.map((link) => {
              return {
                label: link["nlp_redirect_link_value"],
                value: link["nlp_redirect_link_value"]
              }
            })
          })
          break
        case apiResponse.ERROR:
          
          break
        default:
          break
      }
    })

    this.updateBloc.fetchRedirectLink();

    const queryParams = new URLSearchParams(window.location.search);
    this.updateBloc.fetchDetail({nlp_keyword_id: queryParams.get("id")});
  }

  componentWillUnmount() {
    this.updateBloc.createChannel.unsubscribe();
    this.updateBloc.detailChannel.unsubscribe();
    this.updateBloc.rowtableChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Buat Layanan Portal</CardTitle>
                  <CardSubtitle className="mb-3">
                    Buat layanan portal baru dengan mengisi form di bawah ini
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                  >

                    <AvField
                      name="nlp_keyword_id"
                      type="hidden"
                      value={this.state.detail.nlp_keyword_id}
                      id="nlp_keyword_id"
                    />

                    <Row className="mb-3">
                      <label
                        htmlFor="fielCode"
                        className="col-md-3 col-form-label"
                      >
                        Keyword <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          name="nlp_keyword_value"
                          type="text"
                          errorMessage="Masukan keyword"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="nlp_keyword_value"
                          value={this.state.detail.nlp_keyword_value}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="is_popup_announcement"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Keyword <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <CustomSelect
                          name="nlp_keyword_type"
                          id="nlp_keyword_type"
                          options={this.state.optKeywordType}
                          validate={{ required: { value: true } }}
                          defaultValue={this.state.selectedKeywordType}
                          onChange={(data) => {
                            this.setState({
                              selectedKeywordType: data.value
                            })
                          }} />
                      </Col>
                    </Row>
                    {this.state.selectedKeywordType == 1 && (
                      <Row className="mb-3">
                        <label
                          htmlFor="is_popup_announcement"
                          className="col-md-3 col-form-label"
                        >
                          Link Internal <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                          <CustomSelect
                            name="nlp_keyword_redirect_link"
                            id="nlp_keyword_redirect_link"
                            options={this.state.optRedirectLink}
                            validate={{ required: { value: true } }}
                            defaultValue={this.state.detail.nlp_keyword_redirect_link} />
                        </Col>
                      </Row>
                    )}
                  
                    {this.state.selectedKeywordType == 2 && (
                      <Row className="mb-3">
                        <label
                          htmlFor="fielCode"
                          className="col-md-3 col-form-label"
                        >
                          Link Eksternal  <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                          <AvField
                            name="nlp_keyword_redirect_link"
                            type="text"
                            errorMessage="Masukan link"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="nlp_keyword_redirect_link"
                            value={this.state.detail.nlp_keyword_redirect_link}
                          />
                        </Col>
                      </Row>
                    )}

                    <Row className="mb-3">
                      <label
                        htmlFor="is_popup_announcement"
                        className="col-md-3 col-form-label"
                      >
                        Status <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <CustomSelect
                          name="nlp_keyword_status"
                          id="nlp_keyword_status"
                          options={this.state.optStatus}
                          validate={{ required: { value: true } }}
                          defaultValue={this.state.selectedStatus}
                          onChange={(data) => {
                            this.setState({
                              selectedStatus: data.value
                            })
                          }} />
                      </Col>
                    </Row>
                    
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <div className="form-check form-switch mb-3">
                          <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                            <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                          </AvCheckboxGroup>

                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/admin/keyword.html">
                          <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                        </Link>
                        {' '}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"

          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"

          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"

          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"

          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}

          response={this.confirmResponse}
        />
        {this.state.redirect ?
          <Redirect to='/admin/keyword.html' />
          : null}
      </Fragment>
    )
  }

}

export default IndexView